import { useState } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Reservation } from "../components/Reservation";
import { Promotions } from "../components/Promotions";
import { Gallery } from "../components/Gallery";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { WhatsappFloat } from "../components/WhatsappFloat";

export default function HomePage() {
  const [preselected, setPreselected] = useState(null);

  const onReserve = (service) => {
    setPreselected({ ...service, _ts: Date.now() });
  };

  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services onReserve={onReserve} />
        <Promotions />
        <Reservation preselectedService={preselected} />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsappFloat />
    </div>
  );
}
